import { captureException as _captureException } from '@sentry/react';

import { createLog } from './src/logging/logger';
import { groupedCaptureArgs } from './src/monitoring/captureGrouping';

export const captureException = (exception: unknown, context?: Parameters<typeof _captureException>[1]): string => {
  process.env.NODE_ENV !== 'production' && console.error(exception, context);
  return _captureException(
    ...(groupedCaptureArgs(exception, context, captureException) as Parameters<typeof _captureException>),
  );
};

export const Log = createLog();
